// Small formatters for the loop's pages (Part A, 3 Nov 2026).

/** "1st", "2nd", "3rd", "4th", "11th", "21st", "112th". */
export function ordinal(n: number): string {
  const tens = n % 100;
  if (tens >= 11 && tens <= 13) return `${n}th`;
  const ones = n % 10;
  return `${n}${ones === 1 ? 'st' : ones === 2 ? 'nd' : ones === 3 ? 'rd' : 'th'}`;
}

export const points = (n: number): string => n.toLocaleString('en-GB');

const dayMonth = (t: number) => new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', day: 'numeric', month: 'short' }).format(new Date(t));
/** "2 to 8 Nov": the week's Monday to its Sunday (`end` is the next Monday). */
export function weekLabel(start: number, end: number): string {
  const sunday = end - 12 * 3600_000; // inside the Sunday whatever the clock change
  const a = dayMonth(start); const b = dayMonth(sunday);
  const [ad, am] = a.split(' '); const [, bm] = b.split(' ');
  return am === bm ? `${ad} to ${b}` : `${a} to ${b}`;
}

export const streakLabel = (n: number): string => `${n} ${n === 1 ? 'day' : 'days'}`;
